import React, { Component, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import ChartCard from "./ChartCard";

function Dashboards(props) {
  const toast = useRef(null);

  useEffect(() => {
    console.log("aaaa");
  }, []);

  return (
    <div>
      <Toast
        ref={toast}
        position="top-left"
        style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
      />
      <div className="row">
      <div className="col-12">
          <ChartCard
           timeFilter={{
            today : false,
            yesterday: false,
            week: true,
            mounth: true
           }}
            options={{
              chart: {
                type: "line",
              },
              title: {
                text: "فروش اقساطی سامانه",
              },
              plotOptions: {
                column: {
                  colorByPoint: true,
                },
              },
              tooltip: {
                formatter: function () {
                  return this.y
                    .toString()
                    .replace(/,/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                },
              },
            }}
            method="getSalesInDashboard"
          />
        </div>
        <div className="col-12 mt-5">
          <ChartCard
           timeFilter={{
            today : true,
            yesterday: true,
            week: true,
            mounth: true
           }}
            options={{
              chart: {
                type: "column",
              },
              title: {
                text: "فروش فروشگاهها",
              },
              plotOptions: {
                column: {
                  colorByPoint: true,
                },
              },
              tooltip: {
                useHTML: true,
                formatter: function () {
                  return (`<div style='font-family:tahoma'>
                    <div>
                     ${this.y
                        .toString()
                        .replace(/,/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 
                    </div>
                    <div>
                      ${this.x}
                    </div>
                  </div>`)
                },
              },
            }}
            method="getShopSalesInDashboard"
          />
        </div>
        <div className="col-lg-6 col-12  mt-5">
          <ChartCard
            timeFilter={false}
            options={{
              chart: {
                type: "pie",
              },
              title: {
                text: "شارژ-اینترنت-قبض-ویلا",
              },
              plotOptions: {
                column: {
                  colorByPoint: true,
                },
              },
              tooltip: {
                formatter: function () {
                  return this.y
                    .toString()
                    .replace(/,/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                },
              },
            }}
            method="getExtraPaymentInDashboard"
          />
        </div>
        <div className="col-lg-6 col-12  mt-5">
          <ChartCard
           timeFilter={false}
            options={{
              chart: {
                type: "pie",
              },
              title: {
                text: "کیف پول ها",
              },
              plotOptions: {
                column: {
                  colorByPoint: true,
                },
              },
              tooltip: {
                formatter: function () {
                  return this.y
                    .toString()
                    .replace(/,/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                },
              },
            }}
            method="getWalletsInDashboard"
          />
        </div>
      </div>
    </div>
  );
}

export default Dashboards;
